import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isLoading: false,
    pendingCount: 0
  }),
  actions: {
    startLoading() {
      this.pendingCount += 1
      this.isLoading = true
    },
    stopLoading() {
      this.pendingCount = Math.max(0, this.pendingCount - 1)
      this.isLoading = this.pendingCount > 0
    },
    reset() {
      this.pendingCount = 0
      this.isLoading = false
    }
  }
})
